import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import AddingColorTokens from './AddingColorTokens';
import ClientProvider from './client';
export default createDemo(import.meta.url, AddingColorTokens, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/adding-color-tokens/AddingColorTokens.tsx",
    "fileName": "AddingColorTokens.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport { blue } from '@mui/material/colors';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\ndeclare module '@mui/material/styles' {\n  interface PaletteColor {\n    darker?: string;\n  }\n\n  interface SimplePaletteColorOptions {\n    darker?: string;\n  }\n}\n\nconst theme = createTheme({\n  palette: {\n    primary: {\n      light: blue[300],\n      main: blue[500],\n      dark: blue[700],\n      darker: blue[900],\n    },\n  },\n});\n\nexport default function AddingColorTokens() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">light</Typography>\n          <Box sx={{ bgcolor: `primary.light`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">main</Typography>\n          <Box sx={{ bgcolor: `primary.main`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">dark</Typography>\n          <Box sx={{ bgcolor: `primary.dark`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">darker</Typography>\n          <Box sx={{ bgcolor: `primary.darker`, width: 40, height: 20 }} />\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 51,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport { blue } from '@mui/material/colors';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\ndeclare module '@mui/material/styles' {\n  interface PaletteColor {\n    darker?: string;\n  }\n\n  interface SimplePaletteColorOptions {\n    darker?: string;\n  }\n}\n\nconst theme = createTheme({\n  palette: {\n    primary: {\n      light: blue[300],\n      main: blue[500],\n      dark: blue[700],\n      darker: blue[900],\n    },\n  },\n});\n\nexport default function AddingColorTokens() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">light</Typography>\n          <Box sx={{ bgcolor: `primary.light`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">main</Typography>\n          <Box sx={{ bgcolor: `primary.main`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">dark</Typography>\n          <Box sx={{ bgcolor: `primary.dark`, width: 40, height: 20 }} />\n        </Stack>\n        <Stack sx={{ alignItems: 'center' }}>\n          <Typography variant=\"body2\">darker</Typography>\n          <Box sx={{ bgcolor: `primary.darker`, width: 40, height: 20 }} />\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 51,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/colors",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
